import { render, staticRenderFns } from "./goodsFrom.vue?vue&type=template&id=67aa044c&scoped=true"
import script from "./goodsFrom.vue?vue&type=script&lang=js"
export * from "./goodsFrom.vue?vue&type=script&lang=js"
import style0 from "./goodsFrom.vue?vue&type=style&index=0&id=67aa044c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa044c",
  null
  
)

export default component.exports